module.exports = __webpack_public_path__ + "static/img/gt-aim.d78d081.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Shared/Login/gt-aim.png
// module id = 185
// module chunks = 0